import {Descriptions} from 'antd';
import React from 'react';

import {IFieldMeta, EFieldType} from 'entities/metadata';

import {createStringDate} from '../../table/utils/table.utils';

export const directoryItemDescriptionTypeResolver = (
    field: IFieldMeta,
    data: any,
) => {
    if (field.type === EFieldType.DATE) {
        return (
            <Descriptions.Item
                label={field.label}
                key={field.key}
            >
                {createStringDate(data[field.key], field.dateFormat)}
            </Descriptions.Item>
        );
    }
    return (
        <Descriptions.Item
            label={field.label}
            key={field.key}
        >
            {data[field.key]}
        </Descriptions.Item>

    );
};
